import { AssetStore } from './asset.store';
import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { Asset } from '../../squidex';
import { IAssetState } from './asset.state';

@Injectable({ providedIn: 'root' })
export class AssetQuery extends QueryEntity<IAssetState, Asset>  {

    constructor(store: AssetStore) {
        super(store);
    }
}
